import React, { useEffect } from 'react';
import PageLayout from '../../components/PageLayout';
import HeaderIcon from '../../icons/newicons/people-fill.svg';
import IconUsersGrey from '../../icons/pos_user.png';
import IconUsersWhite from '../../icons/rev_user.png';
import IconGroupsGrey from '../../icons/pos_user-group.png';
import IconGroupsWhite from '../../icons/rev_user-group.png';
import HeaderIconSvg from '../../icons/newicons/arrow-down-up.svg';
import Entities from '../Entities';
import { useState } from 'react';
import Toggle from 'react-toggle';
import { getLoginDetails } from '../../utils/storage';
import FormInput from '../../components/FormInput';
import Button from '../../components/Button';
import Toast from '../../components/Toast';
import ActionLoader from '../../components/ActionLoader';
import ImageUploading from '../../components/AddEditItems/ImageUpload';
import { SIGNUP_URL, FILE_UPLOAD_URL, STATES_LIST, postData, uploadFile, getData, GET_USER_DETAILS_URL, putData, EDIT_USER_URL } from '../../utils/api';
import useIsMobile from '../../hooks/useIsMobile';

const normalizeInput = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (value.length > 0) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
    return `${currentValue.slice(0, 3)}-${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

export const Groups = (props) => {
  const isMobile = useIsMobile();

  const [searchVal, setSerchVal] = useState('');
  const [removeTabs, setRemoveTabs] = useState(false);
  const [isFranchise, setIsFranchise] = useState(false);
  
  const loginDetails = getLoginDetails();
  const { hierarchy, companyId } = loginDetails || {};
  
  // Check if we should show profile form instead of tabs
  const shouldShowProfileForm = hierarchy === 2 && !companyId;
  
  // Form state
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [driversLicense, setDriversLicense] = useState('');
  const [notes, setNotes] = useState('');
  const [smsNumber, setSmsNumber] = useState('');
  const [image, setImage] = useState(null);
  const [driversLicenseUrl, setDriversLicenseUrl] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [driversLicenseImageUrl, setDriversLicenseImageUrl] = useState(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingUserData, setIsFetchingUserData] = useState(false);
  const [userData, setUserData] = useState(null);
  const [toastParams, setToastParams] = useState({
    message: '',
    type: '',
    id: '',
  });
  
  useEffect(() => {
    if (window.location.pathname.includes('/Franchise')) {
      setIsFranchise(true);
    } else {
      setIsFranchise(false);
    }
  }, [window.location.pathname]);

  // Fetch user details from API when profile form should be shown
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (shouldShowProfileForm && !userData && !isFetchingUserData) {
        setIsFetchingUserData(true);
        try {
          const response = await getData(GET_USER_DETAILS_URL);
          setUserData(response);
          // Populate form fields with API response data
          setFirstName(response.firstName || '');
          setLastName(response.lastName || '');
          setEmail(response.email || '');
          setPhone(response.phone || '');
          setAddress(response.address || '');
          setCity(response.city || '');
          setState(response.state || '');
          setZipcode(response.zipcode || '');
          setDriversLicense(response.driversLicense || '');
          setNotes(response.notes || '');
          setSmsNumber(response.smsNumber || '');
          setProfileImageUrl(response.profileUrl || null);
          setDriversLicenseImageUrl(response.driversLicenseUrl || null);
        } catch (error) {
          console.error('Error fetching user details:', error);
          setToastParams({
            type: 'ERROR',
            message: 'Failed to load user details. Please try again.',
            id: new Date().getTime(),
          });
        } finally {
          setIsFetchingUserData(false);
        }
      }
    };

    fetchUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowProfileForm]);
  
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
  const validateFields = () => {
    if (!firstName || firstName.trim().length < 2) {
      setToastParams({
        type: 'ERROR',
        message: 'First Name must be at least 2 characters',
        id: new Date().getTime(),
      });
      return false;
    }
    if (!lastName || lastName.trim().length < 2) {
      setToastParams({
        type: 'ERROR',
        message: 'Last Name must be at least 2 characters',
        id: new Date().getTime(),
      });
      return false;
    }
    if (!email || !isValidEmail(email.trim())) {
      setToastParams({
        type: 'ERROR',
        message: 'Please enter a valid email address',
        id: new Date().getTime(),
      });
      return false;
    }
    if (!phone) {
      setToastParams({
        type: 'ERROR',
        message: 'Phone is required',
        id: new Date().getTime(),
      });
      return false;
    }
    if (!driversLicense) {
      setToastParams({
        type: 'ERROR',
        message: 'Driver License is required',
        id: new Date().getTime(),
      });
      return false;
    }
    return true;
  };
  
  const handleSave = async () => {
    setHasSubmitted(true);
    if (!validateFields()) {
      return;
    }
    
    setIsLoading(true);
    try {
      let profileUrl = '';
      let driversLicenseUrlValue = '';
      
      // Upload profile image if provided
      if (image && image.length > 0 && image[0].file) {
        try {
          const profileResponse = await uploadFile(FILE_UPLOAD_URL, image[0].file);
          profileUrl = profileResponse.imageUrl || '';
        } catch (uploadError) {
          console.error('Profile image upload error:', uploadError);
          setToastParams({
            type: 'ERROR',
            message: 'Failed to upload profile image. Please try again.',
            id: new Date().getTime(),
          });
          setIsLoading(false);
          return;
        }
      } else if (profileImageUrl) {
        // Use existing profile image URL if no new image uploaded
        profileUrl = profileImageUrl;
      }
      
      // Upload driver license image if provided
      if (driversLicenseUrl && driversLicenseUrl.length > 0 && driversLicenseUrl[0].file) {
        try {
          const licenseResponse = await uploadFile(FILE_UPLOAD_URL, driversLicenseUrl[0].file);
          driversLicenseUrlValue = licenseResponse.imageUrl || '';
        } catch (uploadError) {
          console.error('Driver license image upload error:', uploadError);
          setToastParams({
            type: 'ERROR',
            message: 'Failed to upload driver license image. Please try again.',
            id: new Date().getTime(),
          });
          setIsLoading(false);
          return;
        }
      } else if (driversLicenseImageUrl) {
        // Use existing driver license image URL if no new image uploaded
        driversLicenseUrlValue = driversLicenseImageUrl;
      }
      
      // Get userId from userData (API response)
      if (!userData || !userData.userId) {
        setToastParams({
          type: 'ERROR',
          message: 'User ID not found. Please refresh the page.',
          id: new Date().getTime(),
        });
        setIsLoading(false);
        return;
      }
      
      // Prepare edit data - include userId (mandatory) and all edited fields
      // Note: email is not included as it cannot be edited
      const editData = {
        userId: userData.userId,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phone: phone.trim(),
        address: address.trim(),
        city: city.trim(),
        state: state,
        zipcode: zipcode.trim(),
        driversLicense: driversLicense.trim(),
        notes: notes.trim() || '',
        smsNumber: smsNumber.trim() || '',
      };
      
      // Only include image URLs if they exist (either newly uploaded or existing)
      if (profileUrl) {
        editData.profileUrl = profileUrl;
      }
      if (driversLicenseUrlValue) {
        editData.driversLicenseUrl = driversLicenseUrlValue;
      }
      
      // Call edit API with PUT method
      await putData(EDIT_USER_URL, editData);
      
      // Show success message
      setToastParams({
        type: 'SUCCESS',
        message: 'Profile updated successfully!',
        id: new Date().getTime(),
      });
      
      // Reload page after a short delay
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Save error:', error);
      setIsLoading(false);
      setToastParams({
        type: 'ERROR',
        message:
          error?.response?.data?.error ||
          error?.error ||
          'Failed to save profile. Please try again.',
        id: new Date().getTime(),
      });
    }
  };
  
  const handleCancel = () => {
    // Reset form to original values from API response
    if (userData) {
      setFirstName(userData.firstName || '');
      setLastName(userData.lastName || '');
      setEmail(userData.email || '');
      setPhone(userData.phone || '');
      setAddress(userData.address || '');
      setCity(userData.city || '');
      setState(userData.state || '');
      setZipcode(userData.zipcode || '');
      setDriversLicense(userData.driversLicense || '');
      setNotes(userData.notes || '');
      setSmsNumber(userData.smsNumber || '');
      setProfileImageUrl(userData.profileUrl || null);
      setDriversLicenseImageUrl(userData.driversLicenseUrl || null);
    }
    setImage(null);
    setDriversLicenseUrl(null);
    setHasSubmitted(false);
  };
  // If hierarchy=2 and companyId is null, show profile form instead of tabs
  if (shouldShowProfileForm) {
    return (
      <PageLayout heading="Profile" hideSearchBar={true}>
        {toastParams.message && (
          <Toast
            type={toastParams.type}
            message={toastParams.message}
            id={toastParams.id}
          />
        )}
        {(isLoading || isFetchingUserData) && <ActionLoader />}
        <div style={{ 
          padding: isMobile ? '0' : '0 20px', 
          maxWidth: '1200px', 
          margin: '0',
          marginTop: isMobile ? '0' : '-20px',
          minHeight: 'calc(100vh - 200px)'
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            padding: isMobile ? '20px 16px' : '30px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e8e8e8',
            marginTop: isMobile ? '10px' : '0',
          }}>
            <div style={{ marginBottom: '32px' }}>
              <h2 style={{ 
                fontSize: isMobile ? '20px' : '24px', 
                fontWeight: '600', 
                color: '#333',
                margin: '0 0 8px 0',
                paddingBottom: '16px',
                borderBottom: '2px solid #f0f0f0'
              }}>
                Personal Information
              </h2>
            </div>
            
            <div>
              {/* Row 1: First Name, Last Name, Phone */}
              <div className={`flex flex-between ${isMobile ? "flex-column" : ""}`} style={{ gap: "20px", marginBottom: "24px" }}>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    First Name <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setFirstName(e.target.value)}
                    className="wt-100p"
                    value={firstName}
                    hasError={hasSubmitted && (!firstName || firstName.trim().length < 2)}
                  />
                </div>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Last Name <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setLastName(e.target.value)}
                    className="wt-100p"
                    value={lastName}
                    hasError={hasSubmitted && (!lastName || lastName.trim().length < 2)}
                  />
                </div>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Phone <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setPhone(normalizeInput(e.target.value))}
                    className="wt-100p"
                    value={phone}
                    hasError={hasSubmitted && !phone}
                  />
                </div>
              </div>
              
              {/* Row 2: Email, Address, City */}
              <div className={`flex flex-between ${isMobile ? "flex-column" : ""}`} style={{ gap: "20px", marginBottom: "24px" }}>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Email <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    inputType="login"
                    value={email}
                    type="email"
                    className="wt-100p"
                    disabled={true}
                    style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed', opacity: 0.7 }}
                  />
                </div>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Address <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setAddress(e.target.value)}
                    className="wt-100p"
                    value={address}
                    hasError={hasSubmitted && !address}
                  />
                </div>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    City <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setCity(e.target.value)}
                    className="wt-100p"
                    value={city}
                    hasError={hasSubmitted && !city}
                  />
                </div>
              </div>
              
              {/* Row 3: State, Zipcode, Driver License */}
              <div className={`flex flex-between ${isMobile ? "flex-column" : ""}`} style={{ gap: "20px", marginBottom: "24px" }}>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    State <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <select
                    style={{
                      width: '100%',
                      padding: '12px 20px',
                      borderRadius: '20px',
                      border: '1px solid #e0e0e0',
                      fontSize: '14px',
                      backgroundColor: '#f8f9fa',
                      color: '#333',
                      outline: 'none',
                      transition: 'all 0.3s ease',
                    }}
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = '#4a90e2'}
                    onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                  >
                    <option value="">Select State</option>
                    {STATES_LIST.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Zipcode <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setZipcode(e.target.value)}
                    className="wt-100p"
                    value={zipcode}
                    hasError={hasSubmitted && !zipcode}
                  />
                </div>
                <div className={`${!isMobile ? "wt-33p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Driver License <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setDriversLicense(e.target.value)}
                    className="wt-100p"
                    value={driversLicense}
                    hasError={hasSubmitted && !driversLicense}
                  />
                </div>
              </div>
              
              {/* Row 4: Notes, SMS Number */}
              <div className={`flex flex-between ${isMobile ? "flex-column" : ""}`} style={{ gap: "20px", marginBottom: "32px" }}>
                <div className={`${!isMobile ? "wt-50p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    Notes
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setNotes(e.target.value)}
                    className="wt-100p"
                    value={notes}
                  />
                </div>
                <div className={`${!isMobile ? "wt-50p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '8px' 
                  }}>
                    SMS Number
                  </label>
                  <FormInput
                    inputClassName="rounded-pill bg-blue"
                    onChange={(e) => setSmsNumber(normalizeInput(e.target.value))}
                    className="wt-100p"
                    value={smsNumber}
                  />
                </div>
              </div>
              
              {/* Section divider */}
              <div style={{ 
                marginTop: '40px', 
                marginBottom: '32px',
                paddingTop: '32px',
                borderTop: '2px solid #f0f0f0'
              }}>
                <h2 style={{ 
                  fontSize: isMobile ? '20px' : '24px', 
                  fontWeight: '600', 
                  color: '#333',
                  margin: '0 0 24px 0'
                }}>
                  Document Uploads
                </h2>
              </div>
              
              {/* Row 5: Profile Image, Driver License Image */}
              <div className={`flex flex-between ${isMobile ? "flex-column" : ""}`} style={{ gap: "20px", marginBottom: "40px" }}>
                <div className={`${!isMobile ? "wt-50p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '12px' 
                  }}>
                    Profile Image
                  </label>
                  <div className="flex flex-middle">
                    <ImageUploading onChange={setImage} initialImage={profileImageUrl} />
                  </div>
                </div>
                <div className={`${!isMobile ? "wt-50p" : "wt-100p"}`} style={{ flex: 1 }}>
                  <label style={{ 
                    display: 'block', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    color: '#555', 
                    marginBottom: '12px' 
                  }}>
                    Driver License Image
                  </label>
                  <div className="flex flex-middle">
                    <ImageUploading onChange={setDriversLicenseUrl} initialImage={driversLicenseImageUrl} />
                  </div>
                </div>
              </div>
              
              {/* Save and Cancel buttons */}
              <div className="flex flex-middle flex-right" style={{ 
                gap: "16px", 
                marginTop: "40px",
                paddingTop: "32px",
                borderTop: '2px solid #f0f0f0'
              }}>
                <Button
                  type="secondary"
                  onClick={handleCancel}
                  style={{ 
                    minWidth: "140px",
                    height: "44px",
                    fontSize: "15px",
                    fontWeight: "500",
                    borderRadius: "8px"
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  onClick={handleSave}
                  style={{ 
                    minWidth: "140px",
                    height: "44px",
                    fontSize: "15px",
                    fontWeight: "500",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </div>
        
      </PageLayout>
    );
  }
  
  return (
    // <PageLayout
    //   icon={HeaderIconSvg}
    //   onSearchChange={(val) => {
    //     setSerchVal(val);
    //   }}
    //   heading="Users"
    //   searchPlaceholder="Search Users"
    // >
    <div>
      {!removeTabs && (
        <div
          className='flex flex-middle mt-8 flex-between groups-tabs'
          style={{ paddingLeft: isMobile ? 80 : 280, paddingTop: 80 }}
        >
          <div className={`tabs flex`}>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder bg-white c-gray fw-bolder'`}
              onClick={() => {}}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='30'
                height='24'
                fill='currentColor'
                class='bi bi-people-fill'
                viewBox='0 0 16 16'
              >
                <path d='M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' />
                <path
                  fill-rule='evenodd'
                  d='M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z'
                />
                <path d='M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z' />
              </svg>
              <span>
                {window.location.pathname.includes('/Franchise')
                  ? 'Franchise'
                  : 'Customers'}
              </span>
            </div>
            {!window.location.pathname.includes('/Franchise') && (
              <div
                className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 c-white border-gray`}
                onClick={() => {
                  props.history.push(
                    isFranchise
                      ? '/entities/Franchise/users'
                      : '/entities/users'
                  );
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='30'
                  height='24'
                  fill='currentColor'
                  class='bi bi-person-fill'
                  viewBox='0 0 16 16'
                >
                  <path d='M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' />
                </svg>
                <span>Users</span>
              </div>
            )}
            {/* {hierarchy === 1 && (
              <div className="pl-16 pr-16 flex" style={{ border: 0 }}>
                <Toggle
                  onChange={(e) => {
                    setIsFranchise(e.target.checked);
                  }}
                  className="bg-theme"
                  checked={isFranchise}
                />
                <span className="pl-16">Is Franchise</span>
              </div>
            )} */}
            {/* {hierarchy === 1 && (

                <div
              // className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 c-white border-gray`}
              className={!isFranchise?`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 c-white border-gray`:`ht-60 flex flex-middle pl-16 pr-16 fw-bolder bg-white c-gray fw-bolder'`}
              onClick={() => {
                setIsFranchise(!isFranchise)
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="24"
                fill="currentColor"
                class="bi bi-people-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                <path
                  fill-rule="evenodd"
                  d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                />
                <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
              </svg>
              <span>Is Franchise</span>
            </div>
          )} */}
          </div>
        </div>
      )}
      <div>
        <Entities
          {...props}
          isEmbed={false}
          searchVal={searchVal}
          setRemoveTabs={setRemoveTabs}
          hideTop={true}
          isFranchise={isFranchise}
        />
      </div>
    </div>
  );
};

export default Groups;
